import { useCallback, useMemo } from 'react';
import { SingleSelect, type SingleSelectProps } from '@/ui_v3/components/select';
import { type CategoryNode } from '@/views/build/features/category-tree';
type MobileCategorySingleSelectProps = Omit<SingleSelectProps, 'options' | 'onValueChange'> & {
  categoryNodes: CategoryNode[];
  onValueChange: (value: CategoryNode) => void;
};
export const MobileCategorySingleSelect = (props: MobileCategorySingleSelectProps) => {
  const {
    onValueChange,
    ...rest
  } = props;
  const internalOptions = useMemo(() => {
    return props.categoryNodes.map(node => ({
      ...node,
      value: node.nodeId
    }));
  }, [props.categoryNodes]);
  const internalOnValueChange = useCallback((value: string | null) => {
    if (value) {
      const node = props.categoryNodes.find(node => node.nodeId === value);
      if (node) {
        onValueChange(node);
      }
    }
  }, [props.categoryNodes, onValueChange]);
  return <SingleSelect {...rest} options={internalOptions} onValueChange={internalOnValueChange} data-sentry-element="SingleSelect" data-sentry-component="MobileCategorySingleSelect" data-sentry-source-file="MobileCategorySingleSelect.tsx" />;
};